import styled from 'styled-components';
import Footer from '../components/footer/Footer';
import GameHeader from './componant/GameHeader';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GameService from '../../service/game/GameService';
import { isLogin } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
import UserAlert from '../components/userAlert/UserAlert';
import Toast from './componant/Toast';
type Game = {
  game_id: number;
  title: string;
  description: string;
  bracket_size: number;
};
const useGameList = () => {
  const [gameList, setGameList] = useState<any[]>([]);

  const fetchAllGameList = async () => {
    try {
      const limit = 10;
      let page = 1;
      let allGames: any[] = [];

      while (true) {
        const res = await GameService.list(page, limit);
        const list = res?.data?.list || [];

        if (list.length === 0) break;

        allGames = allGames.concat(list);
        page += 1;
      }

      setGameList(allGames);
    } catch (e) {
      console.error('[전체 밸런스 게임 리스트 에러]', e);
    }
  };

  useEffect(() => {
    fetchAllGameList();
  }, []);

  return gameList;
};

const startGameAndNavigate = async (game: any, navigate: any) => {
  try {
    const startRes = await GameService.startPlay(game.game_id);
    const { play_id, player_id } = startRes.data;

    const matchRes = await GameService.getMatch(
      game.game_id,
      play_id,
      1,
      player_id,
    );

    navigate('/game/detail', {
      state: {
        gameData: game,
        matchData: matchRes,
        playId: play_id,
        playerId: player_id,
        title: game.title,
      },
    });
  } catch (error) {
    console.error('[게임 시작 에러]', error);
  }
};

const GameMain = () => {
  const [activeShareIndex, setActiveShareIndex] = useState<number | null>(null);
  const [activeStartIndex, setActiveStartIndex] = useState<number | null>(null);
  const [isActive, setIsActive] = useState(false);
  const gameList = useGameList();
  const navigate = useNavigate();
  const [rankingList, setRankingList] = useState<any[]>([]);
  const handleClick = () => setIsActive(!isActive);
  const { modalDispatch } = useModal();

  const handleLankClick = () => {
    setTimeout(() => {
      navigate('/game/lank');
    }, 500);
  };
  type RankingItem = {
    name: string;
    count: number;
    iidx: number;
    rank?: number;
  };

  useEffect(() => {
    const fetchRankingList = async () => {
      try {
        const res = await GameService.getRanking(0);
        const list: any[] = res.data || [];

        const formatted: RankingItem[] = list
          .map((item: any) => ({
            name: item.address as string,
            count: Number(item.win_cnt),
            iidx: item.iidx as number,
          }))
          .sort((a: RankingItem, b: RankingItem) => b.count - a.count) // ✅ 타입 지정
          .slice(0, 8)
          .map((item: RankingItem, index: number) => ({
            // ✅ item, index 타입 지정
            ...item,
            rank: index + 1,
          }));

        setRankingList(formatted);
      } catch (error) {
        console.error('[우승 랭킹 불러오기 실패]', error);
      }
    };

    fetchRankingList();
  }, []);

  // 이미지 매칭 함수
  const getGameImage = (title: string): string => {
    if (title.includes('오피스텔')) {
      return '/assets/images/game/game_sum01.png';
    }
    if (title.includes('아파트')) {
      return '/assets/images/game/game_sum03.png';
    }
    if (title.includes('농지')) {
      return '/assets/images/game/game_sum04.png';
    }
    if (title.includes('빌라')) {
      return '/assets/images/game/game_sum05.png';
    }
    if (title.includes('상가')) {
      return '/assets/images/game/game_sum06.png';
    }
    if (title.includes('주택')) {
      return '/assets/images/game/game_sum07.png';
    }
    return '/assets/images/game/default.png';
  };

  const handleShareGame = async (game: Game) => {
    const shareData = {
      title: `경매 밸런스 게임: ${game.title}`,
      text: game.description,
      url: `${window.location.origin}/game/share/${game.game_id}`,
    };

    const copyToClipboard = () => {
      navigator.clipboard.writeText(shareData.url).then(() => {
        Toast({
          description: '게임 링크가 클립보드에 복사되었습니다.',
          status: 'success',
        });
      });
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err: any) {
        if (err.name !== 'AbortError') {
          console.log('Web Share API 실패, 클립보드로 대체');
          copyToClipboard();
        }
      }
    } else {
      copyToClipboard();
    }
  };
  const handleShareEndGame = async (game: Game) => {
    const shareData = {
      title: `경매 밸런스 게임: ${game.title}`,
      text: game.description,
      url: `${window.location.origin}/game/event/${game.game_id}`,
    };

    const copyToClipboard = () => {
      navigator.clipboard.writeText(shareData.url).then(() => {
        Toast({
          description: '게임 링크가 클립보드에 복사되었습니다.',
          status: 'success',
        });
      });
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err: any) {
        if (err.name !== 'AbortError') {
          console.log('Web Share API 실패, 클립보드로 대체');
          copyToClipboard();
        }
      }
    } else {
      copyToClipboard();
    }
  };
  return (
    <Container>
      <GameHeader />
      <Content>
        <Inner>
          <GameInfo>
            <GameInfoTop>
              <ImgWrap>
                <div>
                  <img src="/assets/images/icon/icon_trophy.svg" />
                </div>
              </ImgWrap>
              <Title>
                <div>땅집고옥션</div>
                <div>경공매 밸런스 게임</div>
              </Title>
              <Text>
                요즘 HOT한 지역과 매물은 어디? 밸런스 게임으로 투자 안목을
                확인해보세요.
              </Text>
            </GameInfoTop>
            <GameInfoBottom>
              <BottomTitle>
                <img src="/assets/images/icon/icon_target.svg" />
                <div>이런 분들께 추천해요!</div>
              </BottomTitle>
              <BottomText>
                <div>
                  <img src="/assets/images/check/blue_check_32.svg" /> 경공매
                  투자에 관심이 있지만 어떤 물건이 좋을지 모르겠는 분
                </div>
                <div>
                  <img src="/assets/images/check/blue_check_32.svg" /> 여러
                  물건을 비교하며 나만의 투자 기준을 세우고 싶은 분
                </div>
                <div>
                  <img src="/assets/images/check/blue_check_32.svg" /> 재미있게
                  부동산 투자 감각을 키우고 싶은 분
                </div>
              </BottomText>
            </GameInfoBottom>
          </GameInfo>
          <GameBottomWrap>
            <BottomTit>
              <div>
                <img src="/assets/images/icon/icon_fire.svg" />
              </div>
              <div>Hot!</div>
              <div>경공매 밸런스 게임</div>
            </BottomTit>
            <BottomListWrap>
              {gameList.map((game, index) => (
                <BottomList key={game.game_id}>
                  {game.status === 'Y' ? (
                    <BottomBox>
                      <BottomImg>
                        <img src={getGameImage(game.title)} alt="썸네일" />
                        <LankView
                          onClick={() => {
                            if (!isLogin()) {
                              modalDispatch({
                                type: 'USER_ALERT',
                                payload: 'guest',
                              });
                              return;
                            }
                            navigate(`/game/event/${game.game_id}`);
                          }}
                        >
                          <img src="/assets/images/game/white_thropy.svg" />
                          랭킹보기
                        </LankView>
                      </BottomImg>
                      <BottomInfo>
                        <GapDiv>
                          <Description>
                            <span>{game.bracket_size}강</span>
                          </Description>
                          <div>
                            <BottomInfoTitle>{game.title}</BottomInfoTitle>
                            <BottomInfoText>{game.description}</BottomInfoText>
                          </div>
                        </GapDiv>
                        <ButtonWrap>
                          <ShareBtn
                            className={
                              activeShareIndex === index ? 'active' : ''
                            }
                            onClick={() => {
                              setActiveShareIndex(index);

                              handleShareGame(game);

                              setTimeout(() => {
                                setActiveShareIndex(null);
                              }, 500);
                            }}
                          >
                            <div>
                              공유
                              <img src="/assets/images/icon/icon_share_game.svg" />
                            </div>
                          </ShareBtn>
                          <StartBtn
                            className={
                              activeStartIndex === index ? 'active' : ''
                            }
                            onClick={() => {
                              setActiveStartIndex(index);

                              startGameAndNavigate(game, navigate);

                              setTimeout(() => {
                                setActiveStartIndex(null);
                              }, 500);
                            }}
                          >
                            <div>
                              게임시작
                              <img src="/assets/images/icon/icon_game_start.svg" />
                            </div>
                          </StartBtn>
                        </ButtonWrap>
                      </BottomInfo>
                    </BottomBox>
                  ) : (
                    <BottomBox>
                      <BottomImg>
                        <img src={getGameImage(game.title)} alt="썸네일" />
                      </BottomImg>
                      <BottomInfo>
                        <GapDiv>
                          <Description>
                            <span>{game.bracket_size}강</span>
                          </Description>
                          <div>
                            <BottomInfoTitle>{game.title}</BottomInfoTitle>
                            <BottomInfoText>{game.description}</BottomInfoText>
                          </div>
                        </GapDiv>
                        <ButtonWrap>
                          <ShareBtn
                            className={
                              activeShareIndex === index ? 'active' : ''
                            }
                            onClick={() => {
                              setActiveShareIndex(index);

                              handleShareEndGame(game);

                              setTimeout(() => {
                                setActiveShareIndex(null);
                              }, 500);
                            }}
                          >
                            <div>
                              공유
                              <img src="/assets/images/icon/icon_share_game.svg" />
                            </div>
                          </ShareBtn>
                          <StartBtn
                            className={
                              activeStartIndex === index ? 'active' : ''
                            }
                            onClick={() => {
                              setActiveStartIndex(index);

                              navigate(`/game/event/${game.game_id}`);

                              setTimeout(() => {
                                setActiveStartIndex(null);
                              }, 500);
                            }}
                          >
                            <div>결과 확인</div>
                          </StartBtn>
                        </ButtonWrap>
                      </BottomInfo>
                    </BottomBox>
                  )}
                </BottomList>
              ))}
            </BottomListWrap>
          </GameBottomWrap>
          <GameLankingWrap>
            <GameLanking>
              <LankTitle>
                <img src="/assets/images/icon/icon_trophy.svg" />
                우승 물건 랭킹
              </LankTitle>
              <TableBody>
                <TableHeader>
                  <div>순위</div>
                  <div>물건명(주소)</div>
                  <div>우승횟수</div>
                </TableHeader>
                {rankingList.map((item, index) => (
                  <TableList
                    key={index}
                    onClick={() => {
                      if (!isLogin()) {
                        modalDispatch({
                          type: 'USER_ALERT',
                          payload: 'guest',
                        });
                        return;
                      }

                      window.open(`/auction/detail/${item.iidx}`, '_blank');
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <div>
                      {item.rank <= 3 ? (
                        <span>
                          <img
                            src={`/assets/images/icon/lank_medal_${item.rank}.svg`}
                            alt={`rank-${item.rank}`}
                            width={24}
                            height={24}
                          />
                        </span>
                      ) : (
                        <span>{item.rank}</span>
                      )}
                    </div>
                    <div>{item.name}</div>
                    <div>{item.count}회</div>
                  </TableList>
                ))}
              </TableBody>
              <ListBtn
                className={isActive ? 'active' : ''}
                onClick={() => {
                  if (!isLogin()) {
                    modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                    return;
                  }

                  handleClick();
                  handleLankClick();
                }}
              >
                <div>
                  <div>
                    <img
                      src="/assets/images/icon/lank_medal_1.svg"
                      style={{ width: '20px' }}
                    />
                    <div>우승 물건 목록</div>
                  </div>
                  <div>
                    <img
                      src="/assets/images/icon/icon_arrow_right_gray.svg"
                      style={{ width: '8px' }}
                    />
                  </div>
                </div>
              </ListBtn>
            </GameLanking>
          </GameLankingWrap>
        </Inner>
      </Content>
      <Footer />
      <UserAlert />
    </Container>
  );
};

export default GameMain;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f3f4f6;
`;

const Inner = styled.div`
  width: 100%;
`;
const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;

const GameInfo = styled.div`
  display: flex;
  padding: 40px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  background: rgba(211, 235, 255, 0.5);
`;
const GameInfoTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const ImgWrap = styled.div`
  display: flex;
  div {
    display: flex;
    padding: 20px;
    align-items: center;
    gap: 10px;
    border-radius: 12px;
    background: #fff;
    img {
      width: 42px;
      height: 42px;
    }
  }
`;

const Title = styled.div`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 55.1px */
  letter-spacing: -0.76px;
  > div {
    text-align: center;
  }
  > div:first-child {
    color: #000;
  }
  > div:last-child {
    color: #008aff;
  }
`;

const Text = styled.div`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: rgba(0, 12, 30, 0.8);
`;

const GameInfoBottom = styled.div`
  display: flex;
  padding: 16px;
  width: 100%;
  flex-direction: column;
  align-items: start;
  gap: 20px;
  border-radius: 20px;
  background: rgba(0, 138, 255, 0.12);
`;

const BottomTitle = styled.div`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 29px */
  letter-spacing: -0.32px;
  color: #222;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const BottomText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  div {
    img {
      width: 14px;
      height: 14px;
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 145%; /* 26.1px */
    letter-spacing: -0.28px;
    color: rgba(0, 12, 30, 0.8);
  }
`;

const GameInfoTopWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  flex-direction: row;
`;
const GameLankingWrap = styled.div`
  padding: 0 20px 72px;
`;
const GameLanking = styled.div`
  display: flex;
  padding: 24px;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 20px;
  background: #fff;
  flex-direction: column;
`;

const LankTitle = styled.div`
  img {
    width: 24px;
  }
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 34.8px */
  letter-spacing: -0.32px;
  color: #000;
`;

const TableHeader = styled.div`
  display: flex;
  padding: 12px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);
  flex-direction: row;
  div {
    font-family: 'Spoqa Han Sans Neo';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 145%; /* 20.3px */
    letter-spacing: -0.28px;
    color: #6b7684;
  }
  div:nth-child(2) {
    margin-right: auto;
  }
`;
const TableBody = styled.div`
  width: 100%;
  > div:nth-child(2) > div {
    color: #333d4b;
  }
  > div:nth-child(3) > div {
    color: #333d4b;
  }
  > div:nth-child(4) > div {
    color: #333d4b;
  }
`;
const TableList = styled.div`
  display: flex;
  padding: 12px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  flex-direction: row;
  cursor: pointer;
  border-radius: 8px;
  &:hover {
    background: rgba(112, 115, 124, 0.08);
  }
  div {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 145%; /* 23.2px */
    letter-spacing: -0.32px;
    color: #6b7684;
  }
  div:first-child {
    width: 30px;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  div:nth-child(2) {
    margin-right: auto;
    width: 180px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  }
`;

const ListBtn = styled.div`
  width: 100%;
  height: 46px;
  cursor: pointer;
  position: relative;
  > div {
    display: flex;
    width: 100%;
    padding: 12px 20px;
    justify-content: space-between;
    align-items: center;
    border-radius: 12px;
    background: #e6f2fc;
    flex-direction: row;
    transition: 0.1s;
    &:hover {
      background: #e6effc;
    }
    > div {
      font-family: NanumSquareRoundOTF;
      align-items: center;
      display: flex;
      flex-direction: row;
      color: #6b7684;
      font-size: 16px;
      font-weight: 800;
      line-height: 145%;
      letter-spacing: -0.36px;
      gap: 8px;
    }
    position: absolute;
    left: 0;
    top: -3px;
  }
  &::before {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #bfd0e0;
    left: 0;
    z-index: 0;
  }
  &.active {
    > div {
      top: 0px;
    }
  }
`;

const GameBottomWrap = styled.div`
  display: flex;
  gap: 45px;
  flex-direction: column;
  padding: 40px 20px;
  background: #f3f4f6;
`;
const BottomTit = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-direction: row;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 34.8px */
  letter-spacing: -0.4px;
  div:first-child {
    display: flex;
  }
  div:nth-child(2) {
    color: #f04452;
  }
  div:last-child {
    color: #000;
  }
`;

const BottomListWrap = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;
  flex-direction: column;
`;
const BottomList = styled.div`
  position: relative;
  width: calc(100% - 20px);
`;

const BottomBox = styled.div`
  border: 1px solid #e1e2e4;
  border-radius: 20px;
  background: #fff;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
  bottom: 5px;
  overflow: hidden;
`;

const BottomImg = styled.div`
  height: 200px;
  width: 100%;
  position: relative;
  overflow: hidden;
  > img {
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
`;
const BottomInfo = styled.div`
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  gap: 16px;
  > div:first-child {
    display: flex;
    gap: 8px;
    flex-direction: column;
  }
`;

const BottomInfoTitle = styled.div`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.32px;
  color: rgba(0, 12, 30, 0.8);
  margin-bottom: 6px;
`;

const BottomInfoText = styled.div`
  color: #6b7684;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.28px;
`;

const Description = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: rgba(112, 115, 124, 0.08);
  color: #333d4b;

  /* Re_SPOQA/body/bold_12 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
  width: 41px;
`;

const DescriptionInfo = styled.div`
  display: flex;
  width: 76px;
  padding: 10px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
  }
  span:first-child {
    color: #8b95a1;
    font-size: 13px;
  }
  span:last-child {
    color: #333d4b;
    font-weight: 700;
    font-size: 14px;
  }
`;

const DescriptionInfo02 = styled.div`
  display: flex;
  padding: 10px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  flex: 1 0 0;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    gap: 4px;
  }
  span:first-child {
    color: #8b95a1;
    font-size: 13px;
  }
  span:last-child {
    color: #333d4b;
    font-weight: 700;
    font-size: 14px;
  }
`;

const DesBar = styled.div`
  width: 1px;
  height: 24px;
  background: #e1e2e4;
`;

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 6px;
  align-self: stretch;
  flex-direction: row;
`;

const ShareBtn = styled.div`
  width: 79px;
  height: 46px;
  position: relative;
  cursor: pointer;
  > div {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    flex-direction: row;
    gap: 8px;
    display: inline-flex;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #6b7684;
    font-family: NanumSquareRoundOTF;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    line-height: 145%;
    letter-spacing: -0.3px;
    white-space: nowrap;
    position: absolute;
    z-index: 1;
    background: #e6f2fc;
    transition: 0.1s;
    bottom: 0px;
    img {
      width: 15px;
      height: 15px;
    }
    &:hover {
      background: #e6effc;
    }
  }
  &:after {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #bfd0e0;
    display: block;
    content: '';
    position: absolute;
    z-index: 0;
    bottom: -3px;
  }
  &.active {
    > div {
      bottom: -3px;
    }
  }
`;
const StartBtn = styled.div`
  height: 46px;
  width: calc(100% - 85px);
  position: relative;
  cursor: pointer;
  > div {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    flex-direction: row;
    gap: 8px;
    display: inline-flex;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #fff;
    font-family: NanumSquareRoundOTF;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    line-height: 145%; /* 26.1px */
    letter-spacing: -0.36px;
    white-space: nowrap;
    position: absolute;
    z-index: 1;
    background: #1f7aff;
    transition: 0.1s;
    bottom: 0px;
    img {
      width: 20px;
      height: 20px;
    }
    &:hover {
      background: #1957c2;
    }
  }
  &:after {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #0d538f;
    display: block;
    content: '';
    position: absolute;
    z-index: 0;
    bottom: -3px;
  }
  &.active {
    > div {
      bottom: -3px;
    }
  }
`;

const LankView = styled.div`
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.63);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  display: inline-flex;
  padding: 8px 16px;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
  position: absolute;
  color: #fff;
  flex-direction: row;
  bottom: 16px;
  right: 16px;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: rgba(0, 0, 0, 0.78);
  }
`;
const GapDiv = styled.div`
  display: flex;
  gap: 12px;
`;
